// LRPO-5906: assignment-log "Error" badge tooltip.
// The bubble was absolutely positioned inside the table's overflow-x:auto
// scroll wrapper, so it clipped at the wrapper edge. A position:fixed bubble
// placed at the badge's viewport coordinates cannot be clipped.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.content = this.contentTarget;
  }

  show() {
    const rect = this.element.getBoundingClientRect();
    const c = this.content;

    // r2 — re-parent to <body> while shown: no ancestor (scroll wrapper,
    // transformed modal) can clip a fixed element that lives on body. Keep a
    // placeholder comment node so hide() can put it back where it came from.
    if (c.parentElement !== document.body) {
      this.placeholder = document.createComment("error-tooltip");
      c.parentElement.insertBefore(this.placeholder, c);
      document.body.appendChild(c);
    }
    c.style.maxWidth = "260px";
    c.style.whiteSpace = "normal";

    c.style.position = "fixed";
    c.style.display = "block";
    c.style.zIndex = "2000";

    const w = c.offsetWidth || 150;

    // Center under the badge, clamped >=8px from both viewport edges.
    const left = Math.max(
      8,
      Math.min(rect.left + rect.width / 2 - w / 2, window.innerWidth - w - 8)
    );

    // Below the badge; flip above if it would run past the bottom edge.
    let top = rect.bottom + 6;
    if (top + c.offsetHeight > window.innerHeight - 8) {
      top = rect.top - c.offsetHeight - 6;
    }

    c.style.left = left + "px";
    c.style.top = top + "px";
  }

  hide() {
    const c = this.content;
    c.style.display = "none";
    if (this.placeholder && this.placeholder.parentElement) {
      this.placeholder.parentElement.insertBefore(c, this.placeholder);
      this.placeholder.remove();
      this.placeholder = null;
    }
  }

  disconnect() {
    if (this.content) {
      this.hide();
      this.content = null;
    }
  }
}
